import { Icon } from "common/Icon";
import { urls } from "lib/urls";
import _ from "lodash";
import React from "react";
import styles from "./ProfileImg.scss";

// Flexible profile image component.
// Can be used in two ways:
// "manual" mode
// <ProfileImg userId={1234} highlightedPhotoId={4567} />
// "auto" mode
// <ProfileImg user={u} />
// where the user object has a .id and .highlightedPhotoId member

export class ProfileImg extends React.PureComponent {
  static defaultProps = {
    large: false,
    rounded: true,
    flair: "",
  };

  render() {
    const { user, userId, highlightedPhotoId, large, sidebarHeader, style, rounded, flair, ...props } = this.props;
    const _userId = _.get(user, "id") || userId;
    const _highlighted = _.get(user, "highlightedPhotoId") || highlightedPhotoId;
    const _style = rounded ? { ...style, borderRadius: "100%" } : style;

    let size;
    if (sidebarHeader) {
      size = 50;
    } else {
      size = large ? 80 : 40;
    }

    if (_highlighted) {
      const src = large ? urls.photos.centi(_highlighted) : urls.photos.milli(_highlighted);
      const srcSet = large ? `${urls.photos.profile(_highlighted)} 2x` : `${urls.photos.centi(_highlighted)} 2x`;

      if (flair) {
        return (
          <div className={styles.container}>
            <img {...props} height={size} width={size} style={_style} src={src} srcSet={srcSet} />
            <Icon className={styles.flair} i={flair} size={20} />
          </div>
        );
      }

      return <img {...props} height={size} width={size} style={_style} src={src} srcSet={srcSet} />;
    }

    const src = large ? urls.users.profileDefault.large(_userId) : urls.users.profileDefault.small(_userId);
    const srcSet = large
      ? `${urls.users.profileDefault.large2x(_userId)} 2x`
      : `${urls.users.profileDefault.small2x(_userId)} 2x`;

    return <img {...props} height={size} width={size} style={_style} src={src} srcSet={srcSet} />;
  }
}
